export default $axios => {
  return {
    /**
     * 获取验证码
     * @param {object} options
     */
    getCode (options) {
      return $axios.post('/sso/verifycode', options)
    },

    goForm (options) {
      return $axios.post('/sso/login', options)
    }

  }
}